module.exports = __webpack_public_path__ + "img/gift-theOne-bg.08caab4f.png";